﻿import angular from "angular";

import "../../../services/cart";
import "../../../services/datastorage";
import _ from "lodash";

angular.module("folkeuni").component("cartOverview", {
  bindings: {
    cart: "=",
    state: "<",
  },
  controller: function (Cart) {
    var $ctrl = this;

    $ctrl.$onInit = function () {
      loadTicketTypes();
    };

    $ctrl.$onChanges = function (changes) {
      loadTicketTypes();
    };

    function loadTicketTypes() {
      if (!$ctrl.cart || !$ctrl.cart.products) return;
      $ctrl.cart.products.forEach((product) => {
        product.ticketTypes = getTicketTypes(product);
      });
    }

    function getTicketTypes(product) {
      if (!product.tickets) return [];
      const grouped = _.groupBy(product.tickets, "type");
      return Object.keys(grouped).map((type) => ({
        name: getTicketTypeName(type),
        count: grouped[type].length,
      }));
    }

    function getTicketTypeName(type) {
      const names = {
        Normal: "Standard",
        Student: "Studerende",
      };
      return names[type] || type;
    }
  },

  templateUrl: "/shop-dist/templates/cart-overview.html?c=" + window.cacheBurst,
  transclude: true,
});
